import { render, staticRenderFns } from "./SelectFieldsAndParameters.vue?vue&type=template&id=49c252c4&scoped=true"
import script from "./SelectFieldsAndParameters.vue?vue&type=script&lang=js"
export * from "./SelectFieldsAndParameters.vue?vue&type=script&lang=js"
import style0 from "./SelectFieldsAndParameters.vue?vue&type=style&index=0&id=49c252c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c252c4",
  null
  
)

export default component.exports